import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { FaPlus, FaUserCog } from 'react-icons/fa';
import { Outlet, useMatch, useResolvedPath } from 'react-router-dom';
import BackButton from '../../../../Components/BackButton';
import { checkPermission } from '../../../../_helpers/roles/check-roles';

function Cd_Admin() {
  const intl = useIntl();
  let resolved = useResolvedPath('new');
  let isForm = useMatch({ path: resolved.pathname, end: true });
  const { edit: isEdit } = useParams();
  const user = useSelector((state) => state.user.user);
  return (
    <div className="card content-section">
      <div className="card-header">
        <div className="mx-2 mt-4">
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-end align-items-center">
              <h4 className="d-inline-block text-primary">
                <FaUserCog className="me-2" />
                {isForm ? intl.formatMessage({ id: 'new' }) : null}
                &nbsp;
                <FormattedMessage id="cd_admin" />{' '}
                {isEdit ? intl.formatMessage({ id: 'edit_' }) : null}
              </h4>
              <BackButton variant="secondary" style={'mx-3'} noMargin />
            </div>
            {!isForm && checkPermission(user?.active_role, 'Can add cd admin') && !isEdit && (
              <div className="">
                <Link to="new" className="text-light">
                  <Button variant="primary">
                    <FaPlus size={18} className="me-2" />
                    <FormattedMessage id="add_new" />
                  </Button>
                </Link>
              </div>
            )}
          </div>
          <hr />
        </div>
      </div>
      <div className="card-body">
        <Outlet />
      </div>
    </div>
  );
}

export default Cd_Admin;
